import { render, staticRenderFns } from "./sort.vue?vue&type=template&id=fccb58be&scoped=true"
import script from "./sort.vue?vue&type=script&lang=ts"
export * from "./sort.vue?vue&type=script&lang=ts"
import style0 from "./sort.vue?vue&type=style&index=0&id=fccb58be&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_hlqzqdj4q3cge46xolaszrvwji/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fccb58be",
  null
  
)

export default component.exports